import { loc } from "../i18n/survey";

const availableDaysQuestion = {
  name: 'availableDays',
  title: loc("quiz.availableDays.title"),
  description: loc("quiz.availableDays.description"),
  type: 'checkbox',
  choices: [
    {
      value: "Monday",
      text: loc("quiz.availableDays.days.Monday"),
    },
    {
      value: "Tuesday",
      text: loc("quiz.availableDays.days.Tuesday"),
    },
    {
      value: "Wednesday",
      text: loc("quiz.availableDays.days.Wednesday"),
    },
    {
      value: "Thursday",
      text: loc("quiz.availableDays.days.Thursday"),
    },
    {
      value: "Friday",
      text: loc("quiz.availableDays.days.Friday"),
    },
    {
      value: "Saturday",
      text: loc("quiz.availableDays.days.Saturday"),
    },
    {
      value: "Sunday",
      text: loc("quiz.availableDays.days.Sunday"),
    },
  ],
  minSelectedChoices: 3,
  isRequired: true,
  validateMinSelectedChoices: true,
  validators: [{
    "type": "expression",
    "text": loc("quiz.availableDays.minError"),
    "expression": "{availableDays.length} > 1"
  }]
};

export {
  availableDaysQuestion,
}
